<template>
  <div class="w-table-action-wrapper">
    <slot v-if="readonly === null || readonly !== true" />
  </div>
</template>

<script>
export default {
  name: 'WorkTableActionWrapper',
  props: {
    readonly: { type: Boolean, default: null }
  },
};
</script>

<style lang='scss'>
.w-table-action-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
